import get_title from "@/router/module/get_title";
import NomenclatureModelRouterHook from "@/new/auth/nomenclature-model.router-hook";

export default {
  path: "/content/catalog/:modelId/products",
  name: "model-edit__products",
  meta: {
    title: get_title("Модель | Товары"),
    forVisitors: true,
    requiresAuth: true
  },
  component: () => import("@/components/dialogs/catalog/model-edit-products.vue"),
  beforeEnter: NomenclatureModelRouterHook("model.show-products"),
};
